/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const documentUploadStyle = {
  file: {
    color: "primary.main",
    padding: "8px",
  },
  chooseFile: (theme: Theme) => ({
    textAlign: "right",
    paddingRight: "1rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0.5rem 0",
    },
  }),
  input: {
    display: "none",
  },
  label: {
    fontWeight: 400,
    textAlign: "right",
    padding: "0.5rem 2.5rem 0.5rem 0",
  },
  loadingBar: {
    marginLeft: "40%",
    maxWidth: "300px",
  },
};

export default documentUploadStyle;
